class ChartFlipperService {
  applyTableDefinitionDefaults (tableDefinition = {}, { primaryLabel, valueField, valueFormat }) {
    let { cellFormat, props: tableProps } = tableDefinition
    const defaultTableProps = {
      dataColumnWidth: 205,
      labelColumnWidth: 110
    }

    if (primaryLabel) {
      defaultTableProps.primaryLabel = primaryLabel
    }

    if (!cellFormat) {
      const cell = {
        align: 'center',
        format: 'number',
        type: valueFormat,
        variable: valueField
      }
      cellFormat = [ cell ]
    }

    return {
      cellFormat,
      props: {
        ...defaultTableProps,
        ...tableProps
      }
    }
  }
}

export const chartFlipperService = new ChartFlipperService()
